import type { MantineNumberSize } from '@mantine/core';

export const fontSizes: Record<MantineNumberSize, number> = {
  xs: 10,
  sm: 12,
  md: 13,
  lg: 14,
  xl: 16,
};
